export default __webpack_public_path__ + "static/media/loading.69f8f005.svg";